import { render, staticRenderFns } from "./cooperate-info.vue?vue&type=template&id=0c229810&scoped=true&"
import script from "./cooperate-info.vue?vue&type=script&lang=js&"
export * from "./cooperate-info.vue?vue&type=script&lang=js&"
import style0 from "./cooperate-info.vue?vue&type=style&index=0&id=0c229810&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c229810",
  null
  
)

export default component.exports